module.exports = "/dashboard/manage/pages/list-4194aa.html";